import { createApp } from 'vue'
import store from './store'
import Vue3Toastify, { type ToastContainerOptions } from 'vue3-toastify'
import 'flatpickr/dist/flatpickr.css'
import { plugin, defaultConfig } from '@formkit/vue'
import App from './App.vue'
import './index.css'
import './assets/faq-styles.css'
import router from './router'
import config from '../formkit.config'
import * as Sentry from "@sentry/vue";

const app = createApp(App)

// Everything that is NOT prod and NOT localhost counts as test — covers
// test-admin.bizinix.sk, *.ondigitalocean.app and any future staging host.
const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
const isProdHost = hostname === 'admin.bizinix.sk';
const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '';
const isTestHost = !isProdHost && !isLocalhost;

Sentry.init({
  app,
  dsn: "https://da8685d9c29d2e4fb86620369fb84fa2@o4506733218627584.ingest.us.sentry.io/4509604909154304",
  environment: isTestHost ? 'staging' : 'production',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  // Free tier optimization
  tracesSampleRate: isTestHost ? 0 : 0.7, // no transactions on test; 70% on prod
  replaysSessionSampleRate: 0.0, // Disable session replay to save quota
  replaysOnErrorSampleRate: 0.0, // Disable error replay to save quota
});

app.use(store)
app.use(router)
app.use(Vue3Toastify, {
  autoClose: 3000,
} as ToastContainerOptions)
app.use(plugin, defaultConfig(config))
app.mount('#app')
